module.exports = __webpack_public_path__ + "img/paper2.6ac09cd3.png";